/**
 * LYTEWORK TROPHY CUSTOMIZER ENGINE - v8.1 (Mobile-First + UX Fixes)
 * Streamlined: Removed bloat, enhanced mobile UX, trim tab, better text fit
 */

document.addEventListener('DOMContentLoaded', function() {
    if (typeof MODELS === 'undefined') {
        console.error("Trophy Data missing.");
        return;
    }

    // === DOM CACHE ===
    const $ = (sel) => document.querySelector(sel);
    const $$ = (sel) => document.querySelectorAll(sel);
    
    const dom = {
        modal: $('#customizerModal'),
        openBtn: $('.open-customizer-btn'),
        closeBtn: $('.lw-plaque-close'),
        tabContainer: $('.lw-plaque-tabs'),
        contentContainer: $('.lw-plaque-tab-content'),
        base: $('#trophyBase'),
        column: $('#trophyColumn'),
        topperImg: $('#trophyTopperImg'),
        trimWrapper: $('#trophyTrimWrapper'),
        trimImg: $('#trophyTrimImg'),
        heightDisplay: $('#heightDisplay'),
        heightInput: $('#heightInput'),
        heightMarkers: $('#heightMarkers'),
        topperSelect: $('#topperSelect'),
        trimSelect: $('#trimSelect'),
        modelSelect: $('#modelSelect'),
        topperCategory: $('#topperCategorySelect'),
        trimCategory: $('#trimCategorySelect'),
        //inputLine1: $('#engravingLine1'),
        //inputLine2: $('#engravingLine2'),
       // inputLine3: $('#engravingLine3'),
        plateLine1: $('#plateLine1'),
        plateLine2: $('#plateLine2'),
        plateLine3: $('#plateLine3'),
        forcedModelInput: $('#forcedModelId'),
        basePriceInput: $('#trophyBasePrice'),
        addToCartBtn: $('#addToCartBtn'),
        priceTag: $('#priceTag'),
        footerQtyInput: null, // Will be set after injection
        multiContainer: $('#multiColumnContainer'),
        colLeft: $('#colLeft'),
        colRight: $('#colRight'),
        colCenterBack: $('#colCenterBack'),
        colBackLeft: $('#colBackLeft'),
        colBackRight: $('#colBackRight'),
        lid: $('#trophyLid'),
        lidContainer: $('#lidContainer'),
        lidEagleLeft: $('#lidEagleLeft'),
        lidEagleRight: $('#lidEagleRight'),
        lidEagleBackLeft: $('#lidEagleBackLeft'),
        lidEagleBackRight: $('#lidEagleBackRight'),
        multiTopperWrapper: $('#multiTopperWrapper'),
        singleTopperWrapper: $('#singleTopperWrapper'),
        cupImg: $('#trophyCupImg'),
        multiTopperScaleWrapper: $('#multiTopperScaleWrapper'),
        trimRiser: $('#trimRiser'),
        previewStage: $('.preview-stage'),
        anchor: $('#trophyAnchor'),
        gridOverlay: $('#gridOverlay')
    };

    // === STATE ===
    const state = {
        model: 'standard',
        modelKey: 'standard',
        topper: null,
        trim: null,
        columnColor: "Red",
        baseColor: "Black Marble",
        basePriceMod: 0,
        heightLabel: 6,
        quantity: 1,
        fontSizes: [10, 10, 10],
        trophies: [{ line1: "", line2: "", line3: "" }],
        isMobile: window.innerWidth <= 768,
        modelHasTrim: false,
        isUploadMode: false,
        isSingleFigure: false
    };

    // === UTILITIES ===
    const isMobile = () => window.innerWidth <= 768;
    
    const debounce = (fn, delay = 100) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    };

    // === SCROLL LOCK ===
    let savedScrollY = 0;
    
    function lockBodyScroll() {
        savedScrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }
    
    function unlockBodyScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        window.scrollTo(0, savedScrollY);
    }
    
    function closeModal() {
        dom.modal.classList.remove('active');
        unlockBodyScroll();
    }

    // === INIT ===
    function init() {
        // ADD THIS: Move modal to body to prevent CSS transform stacking context issues
        if (dom.modal && dom.modal.parentNode !== document.body) {
            document.body.appendChild(dom.modal);
        }
        injectFooterQuantity();
        injectTrimTab();
        renderCategories();
        renderTrimCategories();
        renderTopperList('all');
        renderTrimList('standard');
        setupEventListeners();
        renderTextTable();
        initTextTab();
        
        // Check forced model
        if (dom.forcedModelInput?.value && MODELS[dom.forcedModelInput.value]) {
            dom.modelSelect.value = dom.forcedModelInput.value;
            dom.modelSelect.style.display = 'none';
            const label = dom.modelSelect.previousElementSibling;
            if (label?.tagName === 'H4') label.style.display = 'none';
        }

        // Select first topper
        dom.topperSelect.querySelector('.item-btn')?.click();
        
        // Initialize layout
        updateModelLayout(false);
        
        // Get initial colors
        const activeCol = $('#columnSelect .lw-color-option.active');
        const activeBase = $('#baseSelect .lw-color-option.active');
        if (activeCol) state.columnColor = activeCol.title;
        if (activeBase) state.baseColor = activeBase.title;
        
        applyCurrentStyles();
        updatePrice();
        handleResize();
        
        // Update trim tab visibility
        updateTrimTabVisibility();
    }

    // === FOOTER QUANTITY ===
    function injectFooterQuantity() {
        const footer = $('.lw-plaque-footer');
        const priceDiv = footer.querySelector('.lw-plaque-price');
        
        const qtyWrapper = document.createElement('div');
        qtyWrapper.className = 'lw-footer-qty';
        qtyWrapper.innerHTML = `
            <label>Qty:</label>
            <div class="lw-qty-compact">
                <button type="button" class="lw-qty-btn-sm" data-action="decrease">&#8722;</button>
                <input type="number" class="lw-qty-input-sm" value="1" min="1" max="100">
                <button type="button" class="lw-qty-btn-sm" data-action="increase">+</button>
            </div>
        `;
        
        // Insert between price and button
        footer.insertBefore(qtyWrapper, dom.addToCartBtn);
        dom.footerQtyInput = qtyWrapper.querySelector('.lw-qty-input-sm');
        
        // Event listeners for footer qty
        qtyWrapper.addEventListener('click', (e) => {
            if (e.target.classList.contains('lw-qty-btn-sm')) {
                e.preventDefault();
                let val = parseInt(dom.footerQtyInput.value);
                dom.footerQtyInput.value = e.target.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
                handleQuantityChange(parseInt(dom.footerQtyInput.value));
            }
        });
        
        dom.footerQtyInput.addEventListener('change', (e) => {
            handleQuantityChange(Math.max(1, parseInt(e.target.value) || 1));
        });
    }
    
    function handleQuantityChange(qty) {
        state.quantity = qty;
        dom.footerQtyInput.value = qty;
        
        // Re-render the text table
        renderTextTable();
        
        updatePrice();
    }
    

    // === TRIM TAB (Conditional) ===
    function injectTrimTab() {
        const trimTabBtn = document.createElement('button');
        trimTabBtn.className = 'lw-plaque-tab';
        trimTabBtn.type = 'button';
        trimTabBtn.id = 'trimTabBtn';
        trimTabBtn.dataset.tab = 'trim';
        trimTabBtn.textContent = 'Trim';
        trimTabBtn.style.display = 'none'; // Hidden by default
        
        // Insert after "Figures" tab
        const figuresTab = dom.tabContainer.querySelector('[data-tab="components"]');
        figuresTab.insertAdjacentElement('afterend', trimTabBtn);

        const trimPane = document.createElement('div');
        trimPane.id = 'tab-trim';
        trimPane.className = 'tab-pane';
        trimPane.innerHTML = `
            <h4>Trim Figure</h4>
            <select id="trimCategorySelect2" class="lw-text-input">
                <option value="all">All Categories</option>
            </select>
            <div class="selection-grid-wrapper" style="max-height: 300px;">
                <div class="item-select-grid" id="trimSelectDedicated"></div>
            </div>
        `;
        dom.contentContainer.appendChild(trimPane);
        
        // Setup category filter for dedicated trim tab
        const trimCat2 = $('#trimCategorySelect2');
        trimCat2.addEventListener('change', (e) => {
            renderTrimList(dom.modelSelect.value, e.target.value, true);
        });
        
        // Initial population of trim tab categories and items
        const modelKey = dom.modelSelect.value;
        const isMulti = MODELS[modelKey]?.isMulti;
        const cats = [...new Set(TRIMS.filter(t => !t.requiresMulti || (t.requiresMulti && isMulti)).map(t => t.category))];
        trimCat2.innerHTML = '<option value="all">All Categories</option>' + 
            cats.map(c => `<option value="${c}">${c}</option>`).join('');
    }
    
    function updateTrimTabVisibility() {
        const key = dom.modelSelect.value;
        const cfg = MODELS[key];
        const hasTrim = cfg.isMulti || cfg.trim?.visible;
        state.modelHasTrim = hasTrim;
        
        const trimTab = $('#trimTabBtn');
        if (trimTab) {
            trimTab.style.display = hasTrim ? '' : 'none';
        }
        
        // Also hide trim section in Figures tab when there's a dedicated Trim tab
        const trimSection = $('#trimSection');
        if (trimSection) {
            trimSection.style.display = hasTrim ? 'none' : 'none'; // Always hide from figures
        }
    }

    

    // === MOBILE ACCORDION ===
    function initMobileAccordion() {
        const tabs = $$('.lw-plaque-tab');
        const panes = $$('.tab-pane');
        
        // Only first section open on mobile
        panes.forEach((pane, i) => {
            if (i > 0) pane.classList.remove('active');
        });
    }

   // === COMBINED TEXT TAB ===
    function initTextTab() {
        const modeButtons = $$('.mode-btn');
        const textSection = $('#textTableSection');
        const uploadSection = $('#uploadSection');
        
        // Mode toggle handlers
        modeButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                modeButtons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                const isUpload = btn.dataset.mode === 'upload';
                state.isUploadMode = isUpload;
                
                textSection.style.display = isUpload ? 'none' : 'block';
                uploadSection.style.display = isUpload ? 'block' : 'none';
                
                updateValidation();
            });
        });
        
        // Initial render
        renderTextTable();
    }
    
    function renderTextTable() {
        const tbody = $('#textTableBody');
        if (!tbody) return;
        
        // Ensure trophies array matches quantity
        while (state.trophies.length < state.quantity) {
            state.trophies.push({ line1: "", line2: "", line3: "" });
        }
        
        tbody.innerHTML = state.trophies.slice(0, state.quantity).map((t, i) => `
            <tr>
                <td class="row-num">${i + 1}</td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line1" value="${t.line1 || ''}" maxlength="30" placeholder=""></td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line2" value="${t.line2 || ''}" maxlength="30" placeholder=""></td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line3" value="${t.line3 || ''}" maxlength="30" placeholder=""></td>
            </tr>
        `).join('');
        
        // Attach input handlers
        tbody.querySelectorAll('.lw-table-input').forEach(input => {
            input.addEventListener('input', (e) => {
                const idx = parseInt(e.target.dataset.index);
                const field = e.target.dataset.field;
                state.trophies[idx][field] = e.target.value;
                
                // Update plate preview for first trophy
                if (idx === 0) {
                    updatePlatePreview();
                }
                
                updateValidation();
            });
        });
        
        updateValidation();
    }
    // === FILE UPLOAD PARSING ===
    function parseCSV(text) {
        const lines = text.trim().split(/\r?\n/);
        if (lines.length === 0) return [];
        
        // Check if first row is headers
        const firstRow = lines[0].toLowerCase();
        const hasHeaders = firstRow.includes('line 1') || firstRow.includes('line1') || 
                          firstRow.includes('name') || firstRow.includes('text');
        
        const startIndex = hasHeaders ? 1 : 0;
        const results = [];
        
        for (let i = startIndex; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue;
            
            // Parse CSV line (handle quoted values)
            const values = parseCSVLine(line);
            
            results.push({
                line1: values[0] || '',
                line2: values[1] || '',
                line3: values[2] || ''
            });
        }
        
        return results;
    }
    
    function parseCSVLine(line) {
        const values = [];
        let current = '';
        let inQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            
            if (char === '"') {
                inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
                values.push(current.trim());
                current = '';
            } else {
                current += char;
            }
        }
        values.push(current.trim());
        
        return values;
    }
    
    async function handleFileUpload(file) {
        if (!file) return;
        
        const fileName = file.name.toLowerCase();
        let data = [];
        
        try {
            if (fileName.endsWith('.csv')) {
                // Parse CSV
                const text = await file.text();
                data = parseCSV(text);
            } else if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
                // For Excel files, we need SheetJS library
                // Check if it's available
                if (typeof XLSX === 'undefined') {
                    alert('Excel parsing requires the SheetJS library. Please use CSV format instead, or contact support.');
                    return;
                }
                
                const arrayBuffer = await file.arrayBuffer();
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
                
                // Check for headers
                const firstRow = jsonData[0];
                const hasHeaders = firstRow && (
                    String(firstRow[0]).toLowerCase().includes('line') ||
                    String(firstRow[0]).toLowerCase().includes('name')
                );
                
                const startIndex = hasHeaders ? 1 : 0;
                
                for (let i = startIndex; i < jsonData.length; i++) {
                    const row = jsonData[i];
                    if (!row || row.length === 0) continue;
                    
                    data.push({
                        line1: String(row[0] || '').trim(),
                        line2: String(row[1] || '').trim(),
                        line3: String(row[2] || '').trim()
                    });
                }
            } else {
                alert('Please upload a .csv or .xlsx file');
                return;
            }
            
            if (data.length === 0) {
                alert('No data found in file. Make sure your file has content.');
                return;
            }
            
            // Update state with parsed data
            state.trophies = data;
            state.quantity = data.length;
            
            // Update quantity display
            if (dom.footerQtyInput) {
                dom.footerQtyInput.value = data.length;
            }
            
            // Switch to manual mode to show the table
            state.isUploadMode = false;
            const modeButtons = $$('.mode-btn');
            modeButtons.forEach(btn => {
                btn.classList.toggle('active', btn.dataset.mode === 'single');
            });
            
            const textSection = $('#textTableSection');
            const uploadSection = $('#uploadSection');
            if (textSection) textSection.style.display = 'block';
            if (uploadSection) uploadSection.style.display = 'none';
            
            // Render the table with imported data
            renderTextTable();
            
            // Show success message
            alert(`Successfully imported ${data.length} entries! Review the data in the table below.`);
            
        } catch (err) {
            console.error('File parsing error:', err);
            alert('Error reading file. Please check the format and try again.');
        }
    }   
function updateValidation() {
        const validationMsg = $('#validationMessage');
        if (!validationMsg) return;
        
        // Skip validation in upload mode
        if (state.isUploadMode) {
            validationMsg.style.display = 'none';
            dom.addToCartBtn.disabled = false;
            return;
        }
        
        // Check if all trophies have at least one line filled
        let isValid = true;
        for (let i = 0; i < state.quantity; i++) {
            const t = state.trophies[i];
            if (!t || (!t.line1?.trim() && !t.line2?.trim() && !t.line3?.trim())) {
                isValid = false;
                break;
            }
        }
        
        validationMsg.style.display = isValid ? 'none' : 'block';
        dom.addToCartBtn.disabled = !isValid;
    }

    // === RENDER FUNCTIONS ===
    function renderCategories() {
        const cats = [...new Set(TOPPERS.map(t => t.category))];
        dom.topperCategory.innerHTML = '<option value="all">All</option>' + 
            cats.map(c => `<option value="${c}">${c}</option>`).join('');
    }

    function renderTrimCategories() {
        const cats = [...new Set(TRIMS.map(t => t.category))];
        dom.trimCategory.innerHTML = '<option value="all">All</option>' + 
            cats.map(c => `<option value="${c}">${c}</option>`).join('');
    }

    function renderTopperList(filter = 'all') {
        const items = filter === 'all' ? TOPPERS : TOPPERS.filter(t => t.category === filter);
        dom.topperSelect.innerHTML = items.length ? items.map(item => `
            <div class="item-btn${state.topper?.name === item.name ? ' active' : ''}" data-name="${item.name}">
                <img src="${item.url}" loading="lazy" alt="${item.name}">
                <span>${item.name}</span>
            </div>
        `).join('') : '<div class="empty-state">No items found</div>';
        
        // Reattach click handlers
        dom.topperSelect.querySelectorAll('.item-btn').forEach(btn => {
            btn.onclick = () => {
                const item = TOPPERS.find(t => t.name === btn.dataset.name);
                if (item) selectTopper(item, btn);
            };
        });
    }

    function renderTrimList(modelKey, filter = 'all', dedicatedTab = false) {
        const isMulti = MODELS[modelKey]?.isMulti;
        const items = TRIMS.filter(t => 
            (!t.requiresMulti || (t.requiresMulti && isMulti)) && 
            (filter === 'all' || t.category === filter)
        );
        
        // Determine which container to render to
        const targetSelect = dedicatedTab ? $('#trimSelectDedicated') : dom.trimSelect;
        if (!targetSelect) return;
        
        targetSelect.innerHTML = items.length ? items.map(item => {
            const priceTag = item.priceMod > 0 ? `<span class="price-mod">+$${item.priceMod.toFixed(2)}</span>` : '';
            return `
                <div class="item-btn${state.trim?.name === item.name ? ' active' : ''}" data-name="${item.name}">
                    ${item.url ? `<img src="${item.url}" loading="lazy" alt="${item.name}">` : '<div class="no-img">&#10060;</div>'}
                    <span>${item.name}</span>
                    ${priceTag}
                </div>
            `;
        }).join('') : '<div class="empty-state">No items found</div>';
        
        targetSelect.querySelectorAll('.item-btn').forEach(btn => {
            btn.onclick = () => {
                const item = TRIMS.find(t => t.name === btn.dataset.name);
                if (item) selectTrim(item, btn);
            };
        });
    }
function renderTextTable() {
        const tbody = $('#textTableBody');
        if (!tbody) return;
        
        // Ensure trophies array matches quantity
        while (state.trophies.length < state.quantity) {
            state.trophies.push({ line1: "", line2: "", line3: "" });
        }
        
        tbody.innerHTML = state.trophies.slice(0, state.quantity).map((t, i) => `
            <tr>
                <td class="row-num">${i + 1}</td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line1" value="${t.line1 || ''}" maxlength="30"></td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line2" value="${t.line2 || ''}" maxlength="30"></td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line3" value="${t.line3 || ''}" maxlength="30"></td>
            </tr>
        `).join('');
        
        // Attach input handlers
        tbody.querySelectorAll('.lw-table-input').forEach(input => {
            input.addEventListener('input', (e) => {
                const idx = parseInt(e.target.dataset.index);
                const field = e.target.dataset.field;
                state.trophies[idx][field] = e.target.value;
                
                // Update plate preview for first trophy
                if (idx === 0) {
                    updatePlatePreview();
                }
                
                updateValidation();
            });
        });
        
        updateValidation();
    }
    function renderBulkTable() {
        const tbody = $('#bulkTableBody');
        if (!tbody) return;
        
        while (state.trophies.length < state.quantity) {
            state.trophies.push({ line1: "", line2: "", line3: "" });
        }
        
        // Update qty display
        const qtyDisplay = $('#bulkQtyDisplay');
        if (qtyDisplay) qtyDisplay.textContent = state.quantity;
        
        // Show/hide empty state
        const bulkSection = $('#bulkSection');
        const emptyState = $('#bulkEmptyState');
        if (state.quantity > 1) {
            if (bulkSection) bulkSection.style.display = 'block';
            if (emptyState) emptyState.style.display = 'none';
        } else {
            if (bulkSection) bulkSection.style.display = 'none';
            if (emptyState) emptyState.style.display = 'block';
        }
        
        tbody.innerHTML = state.trophies.slice(0, state.quantity).map((t, i) => `
            <tr>
                <td class="row-num">${i + 1}</td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line1" value="${t.line1 || ''}"></td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line2" value="${t.line2 || ''}"></td>
                <td><input type="text" class="lw-table-input" data-index="${i}" data-field="line3" value="${t.line3 || ''}"></td>
            </tr>
        `).join('');
        
        tbody.querySelectorAll('.lw-table-input').forEach(input => {
            input.oninput = (e) => {
                const idx = parseInt(e.target.dataset.index);
                state.trophies[idx][e.target.dataset.field] = e.target.value;
                if (idx === 0) {
                    dom.inputLine1.value = state.trophies[0].line1;
                    dom.inputLine2.value = state.trophies[0].line2;
                    dom.inputLine3.value = state.trophies[0].line3;
                    updatePlatePreview();
                }
            };
        });
    }

    // === SELECTION HANDLERS ===
function selectTopper(item, btn) {
        state.topper = item;
        dom.topperSelect.querySelectorAll('.item-btn').forEach(b => b.classList.remove('active'));
        btn?.classList.add('active');
        
        const transform = `scale(${item.scale}) translateY(${item.offset}px)`;
        dom.topperImg.src = item.url;
        dom.topperImg.style.transform = transform;
        dom.multiTopperScaleWrapper.innerHTML = `<img src="${item.url}" class="trophy-topper-img" style="transform: ${transform}">`;
        
        // Also update base figure for single figure trophy
        if (state.isSingleFigure) {
            const baseFigureImg = $('#baseFigureImg');
            if (baseFigureImg) {
                baseFigureImg.src = item.url;
                baseFigureImg.style.transform = `scale(${(item.scale || 1) * 0.9})`;
            }
        }
        
        handleResize();
    }

    function selectTrim(item, btn) {
        state.trim = item;
        
        // Clear active from both trim selects
        dom.trimSelect?.querySelectorAll('.item-btn').forEach(b => b.classList.remove('active'));
        $('#trimSelectDedicated')?.querySelectorAll('.item-btn').forEach(b => b.classList.remove('active'));
        
        // Set active on clicked button
        btn?.classList.add('active');
        
        // Also set active on the matching item in the other list
        const otherList = btn?.closest('#trimSelect') ? $('#trimSelectDedicated') : dom.trimSelect;
        otherList?.querySelector(`[data-name="${item.name}"]`)?.classList.add('active');
        
        if (item.url) {
            dom.trimWrapper.style.display = 'flex';
            dom.trimImg.src = item.url;
            dom.trimImg.style.transform = item.scale ? `scale(${item.scale})` : 'scale(1)';
        } else {
            dom.trimWrapper.style.display = 'none';
        }
        updatePrice();
    }

    // === PRICING ===
    function getBasePrice() {
        return dom.basePriceInput?.value ? parseFloat(dom.basePriceInput.value) : 9.99;
    }

    function calculateUnitPrice() {
        let price = getBasePrice();
        const height = parseInt(dom.heightInput.value);
        if (SIZE_PRICES?.[height]) price += SIZE_PRICES[height];
        if (state.trim?.priceMod) price += state.trim.priceMod;
        price += state.basePriceMod;
        return price;
    }

    function getSurchargeDetails() {
        const parts = [];
        const height = parseInt(dom.heightInput.value);
        if (SIZE_PRICES?.[height] > 0) parts.push(`Size (${state.heightLabel}"): $${SIZE_PRICES[height].toFixed(2)}`);
        if (state.trim?.priceMod > 0) parts.push(`Trim (${state.trim.name}): $${state.trim.priceMod.toFixed(2)}`);
        if (state.basePriceMod > 0) parts.push(`Base (${state.baseColor}): $${state.basePriceMod.toFixed(2)}`);
        return parts.join(', ');
    }

    function updatePrice() {
        const total = calculateUnitPrice() * state.quantity;
        dom.priceTag.textContent = '$' + total.toFixed(2);
    }

// === BASE MATERIAL OPTIONS ===
function updateBaseMaterialOptions(modelKey) {
    const baseSelect = $('#baseSelect');
    const baseLabel = $('#baseMaterialLabel');
    if (!baseSelect || !baseLabel) return;
    
    const is3or4 = (modelKey === '3post' || modelKey === '4post');
    const is2post = (modelKey === '2post');
    const isSmall = (modelKey === 'figure' || modelKey === 'standard' || modelKey === 'trim');
    
    // Determine Cherry Wood price based on model
    let cherryPrice = 0;
    if (isSmall) cherryPrice = 2.00;
    else if (is2post) cherryPrice = 4.00;
    // 3post and 4post stay at 0
    
    if (is3or4) {
        // 3 and 4 post only have Black Marble and Cherry Wood (both $0)
        baseLabel.textContent = 'Base Finish';
        baseSelect.innerHTML = `
            <div class="lw-color-option active" title="Black Marble Finish" data-type="base" data-price="0" data-url="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/BLACK_MARBLE_SWATCH.jpg?v=1764126163" style="background-image:url('https://cdn.shopify.com/s/files/1/0590/2244/2570/files/BLACK_MARBLE_SWATCH.jpg?v=1764126163'),linear-gradient(#222,#444);"></div>
            <div class="lw-color-option" title="Cherry Wood Finish" data-type="base" data-price="0" data-url="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WOOD_GRAIN_SWATCH.jpg?v=1764126162" style="background-image:url('https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WOOD_GRAIN_SWATCH.jpg?v=1764126162'),linear-gradient(#632,#853);"></div>
        `;
    } else {
        // All other models have all 3 options
        baseLabel.textContent = 'Base Material';
        baseSelect.innerHTML = `
            <div class="lw-color-option active" title="Black Marble" data-type="base" data-price="0" data-url="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/BLACK_MARBLE_SWATCH.jpg?v=1764126163" style="background-image:url('https://cdn.shopify.com/s/files/1/0590/2244/2570/files/BLACK_MARBLE_SWATCH.jpg?v=1764126163'),linear-gradient(#222,#444);"></div>
            <div class="lw-color-option" title="White Marble" data-type="base" data-price="0" data-url="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WHITE_MARBLE_SWATCH.jpg?v=1764126162" style="background-image:url('https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WHITE_MARBLE_SWATCH.jpg?v=1764126162'),linear-gradient(#eee,#fff);"></div>
            <div class="lw-color-option" title="Cherry Wood Finish" data-type="base" data-price="${cherryPrice.toFixed(2)}" data-url="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WOOD_GRAIN_SWATCH.jpg?v=1764126162" style="background-image:url('https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WOOD_GRAIN_SWATCH.jpg?v=1764126162'),linear-gradient(#632,#853);"></div>
        `;
    }
    
    // Reset selection to first option
    const firstOpt = baseSelect.querySelector('.lw-color-option');
    if (firstOpt) {
        state.baseColor = firstOpt.title;
        state.basePriceMod = parseFloat(firstOpt.dataset.price) || 0;
    }
    
    // Update label to show selected material for single figure
    updateBaseMaterialLabel();
    
    applyCurrentStyles();
}
    
    function updateBaseMaterialLabel() {
        const baseLabel = $('#baseMaterialLabel');
        if (!baseLabel) return;
        
        if (state.isSingleFigure) {
            baseLabel.textContent = `Base Material: ${state.baseColor}`;
        } else {
            const is3or4 = (state.modelKey === '3post' || state.modelKey === '4post');
            baseLabel.textContent = is3or4 ? 'Base Finish' : 'Base Material';
        }
    }


    // === LAYOUT ===
function updateModelLayout(reRender = true) {
    const key = dom.modelSelect.value;
    const cfg = MODELS[key];
    state.model = cfg.name;
    state.modelKey = key;
    state.isSingleFigure = cfg.isFigure || false;

    // Update base material options based on model
    updateBaseMaterialOptions(key);

    // Show/hide column height section for single figure
    const heightH4 = dom.heightDisplay?.parentElement;
    if (state.isSingleFigure) {
        dom.heightInput.style.display = 'none';
        dom.heightMarkers.style.display = 'none';
        if (heightH4 && heightH4.tagName === 'H4') heightH4.style.display = 'none';
    } else {
        dom.heightInput.style.display = '';
        dom.heightMarkers.style.display = '';
        if (heightH4 && heightH4.tagName === 'H4') heightH4.style.display = '';
    }
    
    // Show/hide column color section for single figure
    const columnColorSection = $('#columnSelect');
    const columnColorLabel = columnColorSection?.previousElementSibling;
    if (state.isSingleFigure) {
        if (columnColorSection) columnColorSection.style.display = 'none';
        if (columnColorLabel && columnColorLabel.tagName === 'H4') columnColorLabel.style.display = 'none';
    } else {
        if (columnColorSection) columnColorSection.style.display = '';
        if (columnColorLabel && columnColorLabel.tagName === 'H4') columnColorLabel.style.display = '';
    }

    if (reRender) renderTrimList(key, dom.trimCategory.value);
    
    dom.base.style.width = cfg.baseWidth + 'px';
    dom.base.style.height = (cfg.baseHeight || 25) + 'px';
    applyCurrentStyles();
    
    dom.anchor.dataset.baseScale = cfg.zoom || 1;
    
    // Configure height slider - SKIP FOR SINGLE FIGURE
    if (!state.isSingleFigure) {
        const input = dom.heightInput;
        const markers = dom.heightMarkers;
        
        if (cfg.isMulti) {
            if (key === '3post') {
                input.step = 5; input.min = 20; input.max = 30;
                markers.innerHTML = '<span>16"</span><span>20"</span><span>24"</span>';
                if (input.value < 20 || input.value > 30) input.value = 20;
            } else if (key === '4post') {
                input.step = 5; input.min = 24; input.max = 34;
                markers.innerHTML = '<span>18"</span><span>22"</span><span>26"</span>';
                input.value = 24;
            } else {
                input.step = 3; input.min = 16; input.max = 22;
                markers.innerHTML = '<span>10"</span><span>14"</span><span>18"</span>';
                if (input.value < 16 || input.value > 22) input.value = 16;
            }
        } else {
            input.step = 2; input.min = 4; input.max = 8;
            markers.innerHTML = '<span>4"</span><span>6"</span><span>8"</span>';
            if (input.value < 4 || input.value > 8) input.value = 6;
        }
        
        handleHeightChange({ target: input });
    }
    
    applyVisualLayout(cfg);
    
    // Update trim tab visibility based on model
    updateTrimTabVisibility();
}

    function applyCurrentStyles() {
        const baseBtn = $('#baseSelect .lw-color-option.active');
        const colBtn = $('#columnSelect .lw-color-option.active');
        
        if (baseBtn?.dataset.url) {
            const style = `url('${baseBtn.dataset.url}'), linear-gradient(#333, #000)`;
            dom.base.style.backgroundImage = style;
            dom.lid.style.backgroundImage = style;
        }
        
        if (colBtn?.dataset.url) {
            const style = `url('${colBtn.dataset.url}'), linear-gradient(to right, #444, #888, #444)`;
            [dom.column, dom.colLeft, dom.colRight, dom.colCenterBack, dom.colBackLeft, dom.colBackRight, dom.trimRiser]
                .forEach(el => { if (el) el.style.backgroundImage = style; });
        }
    }

function applyVisualLayout(cfg) {
        // Handle single figure trophy (figure directly on base, no column)
        if (cfg.isFigure) {
            // Hide column elements
            dom.column.style.display = 'none';
            dom.multiContainer.style.display = 'none';
            dom.trimWrapper.style.display = 'none';
            dom.trimRiser.style.display = 'none';
            
            // Show the base figure wrapper and copy current topper to it
            const baseFigureWrapper = $('#baseFigureWrapper');
            const baseFigureImg = $('#baseFigureImg');
            if (baseFigureWrapper && baseFigureImg && state.topper) {
                baseFigureWrapper.style.display = 'flex';
                baseFigureImg.src = state.topper.url;
                // Scale down slightly for single figure trophy
                baseFigureImg.style.transform = `scale(${(state.topper.scale || 1) * 0.9})`;
            }
            
            return;
        }
        
        // Hide base figure wrapper for column trophies
        const baseFigureWrapper = $('#baseFigureWrapper');
        if (baseFigureWrapper) baseFigureWrapper.style.display = 'none';
        
        // Reset topper position for column trophies
        if (dom.singleTopperWrapper) {
            dom.singleTopperWrapper.style.bottom = 'calc(100% + 20px)';
        }
        
        if (cfg.isMulti) {
            dom.column.style.display = 'none';
            dom.multiContainer.style.display = 'block';
            
            // Position columns based on post count
            if (cfg.is4Post) {
                dom.colCenterBack.style.display = 'none';
                dom.colBackLeft.style.display = 'block';
                dom.colBackRight.style.display = 'block';
                dom.lidEagleBackLeft.style.display = 'flex';
                dom.lidEagleBackRight.style.display = 'flex';
                dom.colLeft.style.left = 'calc(50% - 210px)';
                dom.colRight.style.left = 'auto';
                dom.colRight.style.right = 'calc(50% - 216px)';
                dom.colBackLeft.style.left = 'calc(50% - 170px)';
                dom.colBackRight.style.left = 'auto';
                dom.colBackRight.style.right = 'calc(50% - 176px)';
            } else if (cfg.is3Post) {
                dom.colCenterBack.style.display = 'block';
                dom.colBackLeft.style.display = 'none';
                dom.colBackRight.style.display = 'none';
                dom.lidEagleBackLeft.style.display = 'none';
                dom.lidEagleBackRight.style.display = 'none';
                dom.colCenterBack.style.left = '50%';
                dom.colCenterBack.style.transform = 'translateX(-50%)';
                dom.colLeft.style.left = 'calc(50% - 193.75px)';
                dom.colRight.style.left = 'auto';
                dom.colRight.style.right = 'calc(50% - 200px)';
            } else {
                dom.colCenterBack.style.display = 'none';
                dom.colBackLeft.style.display = 'none';
                dom.colBackRight.style.display = 'none';
                dom.lidEagleBackLeft.style.display = 'none';
                dom.lidEagleBackRight.style.display = 'none';
                dom.colLeft.style.left = 'calc(50% - 115px)';
                dom.colRight.style.left = 'auto';
                dom.colRight.style.right = 'calc(50% - 121.25px)';
            }
            
            const lidW = cfg.baseWidth - cfg.lidWidthOffset;
            dom.lidContainer.style.width = lidW + 'px';
            dom.lid.style.width = '100%';
            
            // Eagles positioning
            if (cfg.is4Post) {
                dom.lidEagleLeft.style.cssText = 'left:15px;right:auto;transform:scale(1.25)';
                dom.lidEagleRight.style.cssText = 'left:auto;right:15px;transform:scale(1.25)';
                dom.lidEagleBackLeft.style.cssText = 'left:55px;right:auto;transform:scale(1)';
                dom.lidEagleBackRight.style.cssText = 'left:auto;right:55px;transform:scale(1)';
            } else {
                dom.lidEagleLeft.style.cssText = 'left:0;transform:translateX(-5px) translateY(-3px) scale(1)';
                dom.lidEagleRight.style.cssText = 'right:0;left:auto;transform:translateY(-3px) scale(1)';
            }
            
            if (cfg.cupScale) {
                dom.cupImg.style.width = (125 * cfg.cupScale) + 'px';
                dom.multiTopperScaleWrapper.style.transform = `scale(${cfg.figureScale || cfg.cupScale})`;
                dom.multiTopperWrapper.style.bottom = cfg.cupBottomOffset;
            }
            
            dom.trimWrapper.style.display = 'flex';
            dom.trimWrapper.style.width = cfg.trim.size + 'px';
            dom.trimWrapper.style.height = cfg.trim.size + 'px';
            dom.trimWrapper.style.left = '50%';
            dom.trimWrapper.style.transform = 'translateX(-50%)';
            dom.trimWrapper.style.right = 'auto';
            
            if (!dom.trimSelect.querySelector('.active') && dom.trimSelect.firstElementChild) {
                dom.trimSelect.firstElementChild.click();
            }
        } else {
            dom.column.style.display = 'block';
            dom.multiContainer.style.display = 'none';
            dom.trimRiser.style.display = 'none';
            dom.column.style.left = cfg.columnLeft;
            dom.column.style.transform = cfg.columnTransform;
            
            if (cfg.trim.visible) {
                dom.trimWrapper.style.width = cfg.trim.size + 'px';
                dom.trimWrapper.style.height = cfg.trim.size + 'px';
                dom.trimWrapper.style.left = '50%';
                dom.trimWrapper.style.transform = `translateX(${cfg.trim.centerOffset}px)`;
                dom.trimWrapper.style.right = 'auto';
                dom.trimWrapper.style.display = 'flex';
                
                if (!dom.trimSelect.querySelector('.active') && dom.trimSelect.firstElementChild) {
                    dom.trimSelect.firstElementChild.click();
                }
            } else {
                dom.trimWrapper.style.display = 'none';
            }
        }
    }

    function updatePlatePreview() {
    const plate = $('.engraving-plate');
    if (!plate) return;
    
    const plateWidth = plate.offsetWidth || 150;
    const plateHeight = plate.offsetHeight || 18;
    
    // Get text from state.trophies (first trophy)
    const lines = [
        state.trophies[0]?.line1 || '',
        state.trophies[0]?.line2 || '',
        state.trophies[0]?.line3 || ''
    ];
    
    // Count filled lines for font size calculation
    const filledLines = lines.filter(l => l.trim().length > 0);
    const lineCount = Math.max(filledLines.length, 1);
    
    // Calculate base font size to fit all lines
    const lineHeight = plateHeight / lineCount;
    const baseFontSize = Math.min(lineHeight * 0.75, 11);
    
    // Update each line
    [dom.plateLine1, dom.plateLine2, dom.plateLine3].forEach((el, idx) => {
        if (!el) return;
        
        const text = lines[idx];
        el.textContent = text;
        
        // Start with calculated base size
        let fontSize = baseFontSize;
        el.style.fontSize = fontSize + 'px';
        el.style.lineHeight = '1.1';
        
        // Auto-shrink if text is too wide
        if (text.length > 0) {
            const maxWidth = plateWidth * 0.92;
            let attempts = 0;
            while (el.scrollWidth > maxWidth && fontSize > 5 && attempts < 10) {
                fontSize -= 0.5;
                el.style.fontSize = fontSize + 'px';
                attempts++;
            }
        }
    });
}

    // === EVENT LISTENERS ===
    function setupEventListeners() {
        // Modal open/close
        dom.openBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            lockBodyScroll();
            dom.modal.classList.add('active');
            handleResize();
        });
        
        dom.closeBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            closeModal();
        });
        
        $('.lw-plaque-overlay')?.addEventListener('click', () => {
            closeModal();
        });

        // Tabs
        dom.tabContainer.addEventListener('click', (e) => {
            const tab = e.target.closest('.lw-plaque-tab');
            if (!tab) return;
            e.preventDefault();
            
            $$('.lw-plaque-tab').forEach(t => t.classList.remove('active'));
            $$('.tab-pane').forEach(p => p.classList.remove('active'));
            tab.classList.add('active');
            $(`#tab-${tab.dataset.tab}`)?.classList.add('active');
            
            // Render trim list when Trim tab is clicked
            if (tab.dataset.tab === 'trim') {
                const modelKey = dom.modelSelect.value;
                const isMulti = MODELS[modelKey]?.isMulti;
                const trimCat2 = $('#trimCategorySelect2');
                if (trimCat2) {
                    const cats = [...new Set(TRIMS.filter(t => !t.requiresMulti || (t.requiresMulti && isMulti)).map(t => t.category))];
                    trimCat2.innerHTML = '<option value="all">All Categories</option>' + 
                        cats.map(c => `<option value="${c}">${c}</option>`).join('');
                }
                renderTrimList(modelKey, 'all', true);
            }
            
            // Scroll to top of content on mobile
            if (isMobile()) {
                dom.contentContainer.scrollTop = 0;
            }
        });

        // Model & category changes
        dom.modelSelect.addEventListener('change', () => { updateModelLayout(true); updatePrice(); });
        dom.topperCategory.addEventListener('change', (e) => renderTopperList(e.target.value));
        dom.trimCategory.addEventListener('change', (e) => renderTrimList(dom.modelSelect.value, e.target.value));
        
        // Height
        dom.heightInput.addEventListener('input', handleHeightChange);
        
        // Engraving inputs (with null check for hidden inputs)
        [dom.inputLine1, dom.inputLine2, dom.inputLine3].forEach(input => {
            if (input) {
                input.addEventListener('input', updatePlatePreview);
                input.addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
            }
        });

        // Color grids
        ['columnSelect', 'baseSelect'].forEach(id => {
            const grid = $(`#${id}`);
            grid?.addEventListener('click', (e) => {
                const opt = e.target.closest('.lw-color-option');
                if (!opt) return;
                e.preventDefault();
                grid.querySelectorAll('.lw-color-option').forEach(el => el.classList.remove('active'));
                opt.classList.add('active');
                
                if (opt.dataset.type === 'base') {
                    state.baseColor = opt.title;
                    state.basePriceMod = parseFloat(opt.dataset.price) || 0;
                    updateBaseMaterialLabel();
                } else if (opt.dataset.type === 'column') {
                    state.columnColor = opt.title;
                }
                applyCurrentStyles();
                updatePrice();
            });
        });

        // Text mode toggle (new combined tab)
        $$('.mode-btn').forEach(btn => {
            btn?.addEventListener('click', () => {
                $$('.mode-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                const isUpload = btn.dataset.mode === 'upload';
                state.isUploadMode = isUpload;
                
                const textSection = $('#textTableSection');
                const uploadSection = $('#uploadSection');
                
                if (textSection) textSection.style.display = isUpload ? 'none' : 'block';
                if (uploadSection) uploadSection.style.display = isUpload ? 'block' : 'none';
            });
        });
        // File upload handler
        const fileInput = $('#engravingFile');
        if (fileInput) {
            fileInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                    handleFileUpload(file);
                }
            });
        }
        // Add to cart
        dom.addToCartBtn.addEventListener('click', addToCart);
        
        // Resize handler (debounced)
        window.addEventListener('resize', debounce(() => {
            state.isMobile = isMobile();
            handleResize();
        }, 150));
    }

    // === HEIGHT CHANGE ===
    function handleHeightChange(e) {
        const val = parseInt(e.target.value);
        const key = dom.modelSelect.value;
        let display = val;

        // Map internal values to display values
        const maps = {
            '2post': { 16: 10, 19: 14, 22: 18 },
            '3post': { 20: 16, 25: 20, 30: 24 },
            '4post': { 24: 18, 29: 22, 34: 26 }
        };
        if (maps[key]?.[val]) display = maps[key][val];

        state.heightLabel = display;
        dom.heightDisplay.textContent = display + '"';
        
        let px = val * 20;
        if (e.target.min == 4) px *= 2;
        
        [dom.column, dom.colLeft, dom.colRight, dom.colCenterBack, dom.colBackLeft, dom.colBackRight]
            .forEach(el => { if (el) el.style.height = px + 'px'; });
        
        dom.lidContainer.style.bottom = (px - 10) + 'px';
        
        // Calculate riser height
        let riserH = 0;
        const riserMap = {
            '2post': { 19: 60, 22: 100 },
            '3post': { 25: 100, 30: 160 },
            '4post': { 24: 100, 29: 140, 34: 180 }
        };
        if (riserMap[key]) {
            for (const [h, r] of Object.entries(riserMap[key])) {
                if (val >= parseInt(h)) riserH = r;
            }
        }

        if (riserH > 0) {
            dom.trimRiser.style.display = 'block';
            dom.trimRiser.style.height = riserH + 'px';
            const baseOff = parseFloat(MODELS[key].trim.bottom);
            dom.trimWrapper.style.bottom = (baseOff + riserH) + 'px';
            applyCurrentStyles();
        } else {
            dom.trimRiser.style.display = 'none';
            if (MODELS[key].trim.visible) dom.trimWrapper.style.bottom = MODELS[key].trim.bottom;
        }
        
        updatePrice();
        handleResize();
    }

    // === RESIZE HANDLER ===
    function handleResize() {
        if (!dom.anchor.offsetParent) return;
        
        const stageW = dom.previewStage.clientWidth;
        const stageH = dom.previewStage.clientHeight;
        const baseW = 600;
        
        let colH = parseFloat(dom.column.style.height) || 160;
        if (dom.column.style.display === 'none') {
            colH = parseFloat(dom.colLeft.style.height) || 160;
        }
        
        let riserH = 0;
        if (dom.trimRiser.style.display === 'block') {
            riserH = parseFloat(dom.trimRiser.style.height) || 0;
        }

        const totalH = colH + riserH + 40 + 150;
        const isMulti = dom.multiContainer.style.display === 'block';
        const safety = isMulti ? 0.9 : 1.0;

        const scaleW = (stageW / baseW) * safety;
        const scaleH = (stageH / totalH) * 0.75;
        const baseScale = parseFloat(dom.anchor.dataset.baseScale) || 1;
        const scale = Math.min(scaleW, scaleH, 1.0) * baseScale;
        
        dom.anchor.style.transform = `scale(${scale}) translateY(20px)`;
        dom.anchor.style.transformOrigin = 'bottom center';
    }

    // === CART FUNCTIONS ===
    function generateBulkCSV() {
        const rows = [['Line 1', 'Line 2', 'Line 3']];
        state.trophies.slice(0, state.quantity).forEach(t => {
            rows.push([
                `"${(t.line1 || '').replace(/"/g, '""')}"`,
                `"${(t.line2 || '').replace(/"/g, '""')}"`,
                `"${(t.line3 || '').replace(/"/g, '""')}"`
            ]);
        });
        return rows.map(r => r.join(',')).join('\n');
    }

    function showDisclaimerModal() {
        return new Promise((resolve) => {
            const html = `
                <div class="lw-disclaimer-overlay" id="lwDisclaimerOverlay">
                    <div class="lw-disclaimer-modal">
                        <h3>Before You Continue</h3>
                        <div class="lw-disclaimer-content">
                            <p><strong>I agree that:</strong></p>
                            <ul>
                                <li>I have reviewed and verified all spelling and text</li>
                                <li>Modifications after production begins will result in additional charges</li>
                                <li>I have full legal rights to use all submitted content</li>
                                <li>I accept responsibility for any copyright/trademark issues</li>
                                <li>I agree to indemnify LyteWork Engraving LLC from legal claims</li>
                                <li>My "design" is a rendering; adjustments may be made for best fit</li>
                            </ul>
                        </div>
                        <div class="lw-disclaimer-buttons">
                            <button class="lw-btn-secondary" id="lwDisclaimerCancel">Cancel</button>
                            <button class="lw-btn-primary" id="lwDisclaimerAgree">I Agree</button>
                        </div>
                    </div>
                </div>
            `;
            document.body.insertAdjacentHTML('beforeend', html);
            
            const overlay = $('#lwDisclaimerOverlay');
            const agree = $('#lwDisclaimerAgree');
            const cancel = $('#lwDisclaimerCancel');
            
            agree.onclick = () => { overlay.remove(); resolve(true); };
            cancel.onclick = () => { overlay.remove(); resolve(false); };
            overlay.onclick = (e) => { if (e.target === overlay) { overlay.remove(); resolve(false); } };
        });
    }

    async function addToCart(e) {
        e.preventDefault();

        // --- 1. VALIDATION ---
        if (!state.isUploadMode) {
            let isValid = true;
            for (let i = 0; i < state.quantity; i++) {
                const t = state.trophies[i];
                if (!t || (!t.line1?.trim() && !t.line2?.trim() && !t.line3?.trim())) {
                    isValid = false;
                    break;
                }
            }
            if (!isValid) {
                alert('Please fill out at least one line of text for each trophy.');
                return;
            }
        }
        
        const agreed = await showDisclaimerModal();
        if (!agreed) return;

        // --- 2. LOCK BUTTON + SHOW OVERLAY ---
        dom.addToCartBtn.disabled = true;
        const processingOverlay = dom.modal.querySelector('#lw-processing-overlay');
        const loadingOverlay = document.getElementById('lw-loading');
        if (processingOverlay) processingOverlay.classList.add('active');

        const variantId = $('#trophyVariantId')?.value;
        if (!variantId) { 
            alert("Variant ID missing. Please refresh."); 
            dom.addToCartBtn.disabled = false;
            if (processingOverlay) processingOverlay.classList.remove('active');
            return; 
        }
        
        // Ensure Shopify routes are available
        if (!window.Shopify?.routes?.root) {
            console.warn("Shopify routes not ready, using fallback");
            window.Shopify = window.Shopify || {};
            window.Shopify.routes = window.Shopify.routes || {};
            window.Shopify.routes.root = '/';
        }
        
        // Ensure html2canvas is loaded
        if (typeof html2canvas === 'undefined') {
            console.warn("html2canvas not loaded, skipping image capture");
        }

        // Switch to loading overlay for capture + submission
        if (processingOverlay) processingOverlay.classList.remove('active');
        if (loadingOverlay) loadingOverlay.classList.add('active');

        // --- 3. PHOTO STUDIO CAPTURE ---
        let imageUrl = "";
        
        try {
            // --- SCALING & POSITION MAP ---
            const key = state.modelKey || dom.modelSelect.value;
            
            // Defaults (For 3-Post / 4-Post)
            let zoomLevel = 1.18;    
            let topPadding = 725;   
            let marginTop = 0;      // New variable for pulling things UP

            if (key === 'figure') {
                zoomLevel = 6.0;    // Massive Zoom for tiny figure
                topPadding = 0;     // No padding pushing it down
                marginTop = -1200;   // Negative margin pulls it UP (Change this to move higher/lower)
            } else if (key === 'standard' || key === 'trim') {
                zoomLevel = 2.5;    
                topPadding = 0;   
                marginTop = 200;
            } else if (key === '2post') {
                zoomLevel = 1.9;   
                topPadding = 0;   
                marginTop = 400;
            }

            // A. Create Square Studio
            const studio = document.createElement('div');
            studio.id = 'lw-photo-studio';
            studio.style.cssText = `
                position: absolute; 
                top: 0; 
                left: 0; 
                width: 1200px; 
                height: 1200px; 
                background: #ffffff; 
                z-index: -9999; 
                display: flex; 
                flex-direction: column; 
                align-items: center; 
                justify-content: flex-start; 
                padding-top: ${topPadding}px; 
                overflow: hidden;
            `;
            document.body.appendChild(studio);

            // B. Clone and Scale
            const clone = dom.anchor.cloneNode(true);
            clone.style.position = "relative"; 
            
            // Apply Zoom
            clone.style.transform = `scale(${zoomLevel})`; 
            clone.style.transformOrigin = "top center";
            
            // Apply Margin (Pulls trophy UP if negative)
            clone.style.marginTop = `${marginTop}px`;
            
            studio.appendChild(clone);

            // C. Basic Pre-load
            const allElements = clone.querySelectorAll('*');
            const imagesToLoad = [];

            allElements.forEach(el => {
                const style = window.getComputedStyle(el).backgroundImage || el.style.backgroundImage;
                if (style && style.includes('url')) {
                    const match = style.match(/url\(['"]?(.*?)['"]?\)/);
                    if (match && match[1]) {
                        let cleanUrl = match[1].replace(/['"]/g, '');
                        if(!cleanUrl.startsWith('data:') && cleanUrl.length > 5) {
                             imagesToLoad.push(cleanUrl);
                        }
                    }
                }
            });

            if (imagesToLoad.length > 0) {
                // Timeout after 3 seconds to prevent hanging
                const loadWithTimeout = (url) => new Promise(resolve => {
                    const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src = url;
                    img.onload = resolve;
                    img.onerror = resolve;
                    setTimeout(resolve, 3000); // Force resolve after 3 sec
                });
                await Promise.all(imagesToLoad.map(loadWithTimeout));
            }

            // D. Snap Picture
            const canvas = await html2canvas(studio, { 
                backgroundColor: '#ffffff', 
                useCORS: true,      
                allowTaint: false,
                scale: 1.0, 
                logging: false,
                scrollX: 0,
                scrollY: 0,
                windowWidth: 1200,
                windowHeight: 1200
            });

            imageUrl = canvas.toDataURL("image/jpeg", 0.85);

            // Cleanup
            document.body.removeChild(studio);

        } catch (err) {
            console.warn("Image capture skipped:", err);
            const studio = document.getElementById('lw-photo-studio');
            if(studio) document.body.removeChild(studio);
            imageUrl = ""; // Ensure we continue even if capture fails
        }

        // --- 4. PREPARE CART DATA ---
        const unitPrice = calculateUnitPrice();
        const basePrice = getBasePrice();
        const surcharge = Math.round((unitPrice - basePrice) * 100);
        
        const props = {
            'Trophy Model': state.model,
            'Height': state.heightLabel + '"',
            'Column Color': state.columnColor,
            'Base Material': state.baseColor,
            'Topper Figure': state.topper?.name || "None",
            'Trim Figure': state.trim?.name || "None",
            'Engraving Method': state.isUploadMode ? "Bulk/File" : (state.quantity > 1 ? "Bulk Entry" : "Single Plate"),
            '_preview': imageUrl
        };

        if (surcharge > 0) {
            props['_addon_price'] = surcharge.toString();
            props['_surcharge_breakdown'] = getSurchargeDetails();
        }

        if (state.quantity > 1) {
            props['Bulk Order'] = 'Yes';
            props['All Plates Data (CSV)'] = generateBulkCSV();
            const limit = Math.min(state.quantity, 5);
            for (let i = 0; i < limit; i++) {
                const t = state.trophies[i];
                props[`Plate ${i + 1}`] = `${t.line1} | ${t.line2} | ${t.line3}`;
            }
            if (state.quantity > 5) props['Note'] = 'See attached data for full list';
        } else {
            const t = state.trophies[0];
            props['Engraving'] = [t.line1, t.line2, t.line3].filter(Boolean).join(" | ");
        }

        // --- 5. SEND TO SHOPIFY ---
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: state.quantity, properties: props }] })
        })
        .then(res => res.json())
        .then(() => {
            window.location.href = '/cart';
        })
        .catch(err => {
            console.error(err);
            dom.addToCartBtn.disabled = false;
            const pOvl = dom.modal.querySelector('#lw-processing-overlay');
            const lOvl = document.getElementById('lw-loading');
            if (pOvl) pOvl.classList.remove('active');
            if (lOvl) lOvl.classList.remove('active');
            alert("Could not add to cart. Please check connection.");
        });
    }

    // === START ===
    init();
});